import {Component, Injectable,Input,Output,EventEmitter} from '@angular/core'

@Injectable()
export class ShareParamService {
  param: string;
  constructor() { }

  saveSelectedParam(param){
    this.param = param; 
  }
  getSelectedParam()
  {
    return this.param;
  }
}

  